<div class="row">
  <div class="col-md-6">
    <fieldset style="border: 0;" [disabled]="!hasRole('trucks-editor')">
      <form class="form-horizontal" #tankerDataEntry="ngForm">
        <div class="card card-body">
          <div class="form-group row">
            <app-material-pg-input
              label="شماره تانکر"
              type="text"
              name="tankerNumber"
              id="tankerNumber"
              [disabled]="edit"
              [ngModel]="tankerNumber"
              (ngModelChange)="tankerNumber = $event"
              tabindex="1"
              [required]=true>
            </app-material-pg-input>
          </div>
          <div class="form-group row">
              <app-material-organisation-selector
                class="pg-component"
                [(ngModel)]="organisation"
                [organisationLanguage]="'fa'"
                name="organisation"
                [organisations]="organisations"
                [disabled]="edit"
                [placeholder]="'دارنده تانکر'"
                [required]=true>
              </app-material-organisation-selector>
          </div>
          <div class="form-group row">
            <app-material-pg-input
              label="ظرفیت"
              type="text"
              name="capacity"
              id="capacity"
              [(ngModel)]="capacity"
              tabindex="2"
              [required]=true>
            </app-material-pg-input>
          </div>
          <div class="form-group row">
            <app-material-date-range
              id="selectedDate"
              [singleDateSelector]="true"
              [(dateRange)]="dateRange"
              [jalali]="true"
              [placeholder]="'تاریخ تست تانکر'"
              tabindex="4">
            </app-material-date-range>
          </div>
          <div class="form-group row">
            <app-material-pg-input
                label="شماره گواهینامه "
                type="number"
                name="licenseNumber"
                id="licenseNumber"
                [(ngModel)]="licenseNumber"
                tabindex="5"
                [required]=true>
            </app-material-pg-input>
          </div>
          <div class="form-group row">
            <app-material-chunk-file-uploader
                [accept]="'.pdf'"
                name="document"
                [(ngModel)]="currentFiles"
                (ngModelChange)="uploadDocument($event)"
                [required]=true>
            </app-material-chunk-file-uploader>
          </div>
          <div class="form-group row">
            <div class="col-md-12">
              <button
                mat-raised-button
                mat-stroked-button
                type="submit"
                class="pull-right"
                [disabled]="!tankerDataEntry.form.valid"
                (click)="save()"
                tabindex="15"
                value="Save">
                Save
              </button>
            </div>
          </div>
        </div>
        @if (history && history.length > 0) {
          <div class="card card-body">
            <div class="col-md-12">
              <table
                class="table table-sm table-striped table-bordered">
                <thead>
                  <tr>
                    <th>شماره کشنده</th>
                    <th>تاریخ شروع</th>
                    <th>تاریخ پایان</th>
                  </tr>
                </thead>
                <tbody>
                  @for (object of history; track $index) {
                    <tr>
                      <td>{{object.truckNumber}}</td>
                      <td>{{dateFormatter(object.startDate)}}</td>
                      <td>{{dateFormatter(object.endDate)}}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>
        }
      </form>
    </fieldset>
  </div>
  @if (uploadedFileId) {
    <div class="col-md-6">
      <app-material-pdf-viewer [fileId]="uploadedFileId"></app-material-pdf-viewer>
    </div>
  }
</div>
